import type { Mention } from '@/lib/types'

export const mentionBadgeClasses = {
  direct: 'text-success border-success/40 bg-success/10',
  indirect: 'text-warning border-warning/40 bg-warning/10',
  none: 'text-muted-foreground border-border bg-secondary/40',
} satisfies Record<Mention, string>
